import { render, staticRenderFns } from "./teamDetail_matchPanel.vue?vue&type=template&id=f192df86&scoped=true"
import script from "./teamDetail_matchPanel.vue?vue&type=script&lang=js"
export * from "./teamDetail_matchPanel.vue?vue&type=script&lang=js"
import style0 from "./teamDetail_matchPanel.vue?vue&type=style&index=0&id=f192df86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f192df86",
  null
  
)

export default component.exports